export default __webpack_public_path__ + "static/media/Omkar.115857d1.svg";